// HOW TO ADD A SHOT (this is the only file you need to edit):
//   1. Drop the web-sized JPEG (long edge about 1600 px) into public/images/drones/ as name.jpg
//   2. Add ONE object to droneShots below (newest first).
// Only name.jpg is ever referenced here. Keep the full-resolution original (name.full.jpg)
// out of public/, because everything in public/ is deployed.
// No imports, no component changes, no rebuild config.
//
// Fields: src (required), title, location, taken (ISO date), coords ('lat, lon'),
// camera, span ('wide' | 'tall' | 'normal'). Everything except src is optional.
//
// The three entries below point at placeholder files that do not exist yet. The gallery
// shows a labelled placeholder tile for each until you replace them with real photos.
export const droneShots = [
  {
    src: '/images/drones/placeholder-coast-01.jpg',
    title: 'Placeholder: coast',
    span: 'wide',
  },
  {
    src: '/images/drones/placeholder-ridge-02.jpg',
    title: 'Placeholder: ridge',
    span: 'tall',
  },
  {
    src: '/images/drones/placeholder-harbour-03.jpg',
    title: 'Placeholder: harbour',
    span: 'normal',
  },
];

export const droneSection = {
  title: 'Drone Photography',
  intro: 'Shots from my drone, and I keep this gallery growing.',
  moreLabel: 'See the full gallery',
  viewAllHref: undefined, // optional: a link to a larger archive
};

// The landing page shows a compact page of three (one row on desktop), so it stays short
// and fast however many photos are uploaded. Everything is on /gallery.
export const PREVIEW_COUNT = 3;

// Copy for the landing-page pager under the preview grid.
export const dronePager = {
  label: 'Drone photo pages',
  prev: 'Previous',
  next: 'Next',
  prevLabel: 'Previous photos',
  nextLabel: 'Next photos',
  pageLinkLabel: 'Page {page}',
  range: 'Showing {from} to {to} of {total}',
  pageOf: 'Page {page} of {pages}',
  loadError: 'Could not load that page, so the previous photos are still showing.',
};
